module.exports = __webpack_public_path__ + "files/45755c9be355869364646a8ee5f33cfe.png";